var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table_form"},[_c('section',[_c('img',{attrs:{"src":_vm.obj.user_avatar,"alt":""}}),_c('div',[_c('b',[_vm._v(_vm._s(_vm.obj.name))]),_c('p',[_c('span',[_vm._v("兼职号："+_vm._s(_vm.obj.jz_number))])])])]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.invite}},[_vm._v("邀请")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }